import {
    LIST_ADDONS,
    OrderByInput,
    useAddOnListOrder,
    useSetAddOnListOrder,
} from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, useWindowDimensions, View } from 'react-native';
import { useMaxHeight } from '../../shared/hooks/useMaxHeight';
import { CreateAddonButton } from './createAddonButton';
import { useColumnsAddOn } from './useColumnsAddOn';

type AddOnsListProps = {
  filter: any;
  showCheckboxColumn: boolean;
};

export const AddOnsList = ({ filter, showCheckboxColumn }: AddOnsListProps) => {
  const { t } = useTranslation();
  const { containerMaxHeight, listMaxHeight } = useMaxHeight();
  const { width } = useWindowDimensions();

  const { data: addOnOrder } = useAddOnListOrder();
  const { mutateAsync: setAddOnOrder } = useSetAddOnListOrder();

  const columns = useColumnsAddOn(showCheckboxColumn);

  const onOrderByChange = async (orderBy: OrderByInput) => {
    await setAddOnOrder(orderBy);
  };

  const renderEmpty = () => (
    <View style={styles.emptyContainer}>
      <View style={[styles.textWrapper, { maxWidth: width - 10 }]}>
        <Text style={styles.emptyTapText} numberOfLines={2}>
          {t('addOn.textEmpty')}
        </Text>
      </View>
    </View>
  );

  const renderHeaderContent = () => <CreateAddonButton />;

  return (
    <View
      style={[
        styles.addonContainer,
        {
          maxHeight: containerMaxHeight,
        },
      ]}
    >
      <InfiniteDataGrid
        columns={columns}
        query={LIST_ADDONS}
        dataPrefix="addon.listAddons"
        modelName="addon"
        orderBy={addOnOrder}
        pageSize={50}
        filter={filter}
        hideHeader={false}
        listMaxHeight={listMaxHeight}
        paddingBottom={0}
        showScrollIndicator={true}
        onOrderByChange={onOrderByChange}
        textEmpty={renderEmpty()}
        showEmptyTable
        headerContent={renderHeaderContent()}
        exportFileName="addons-export"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  addonContainer: {
    flex: 1,
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: -1,
  },
  emptyContainer: {
    flexDirection: 'column',
    rowGap: 40,
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    width: '100%',
  },
  textWrapper: {
    width: '100%',
  },
  emptyTapText: {
    fontWeight: '700',
    fontSize: 22,
    textAlign: 'center',
  },
});
